import React,{useState,useEffect} from "react";
import {Tooltip} from 'react-tooltip'
import clsx from 'clsx'
import appointmentService from "../../../services/appointment.service";
import { toast } from 'react-toastify';


function AppointmentListItem({ appt, handleCheckboxChange,isAllSelected }) {
  const ConfirmedMessage = ["Not Confirmed","Confirmed by Eyeconx","Confirmed by PMS","Cancelled"]
  const [isSelected,setIsSelected] = useState(false)
  const [prebookedText,setPrebookedText] = useState("Prebooked Reminder")
  const [firstText,setFirstText] = useState("First Reminder")
  const [secondText,setSecondText] = useState("Second Reminder")
  const [LastText,setLastText] = useState("Last Reminder")
  const [sameDayText,setSameDayText] = useState("Sameday Reminder")
  const SentType = ["Not Sent", "Email","Sms","Call","Live Call"]
  const [isExpanded,setIsExpanded] = useState(false)


  const handleCheckbox = (e) => {
    setIsSelected(!isSelected)
    handleCheckboxChange(e)
  }
  useEffect(()=>{
    if(isAllSelected){
      setIsSelected(true)
    }else{
      setIsSelected(false)
    }
  },[isAllSelected])

  useEffect(()=>{
    if(appt.datePrebooked != null){
      let strText1 = "Prebooked Reminder sent on "+appt.datePrebooked+ " by "+appt.prebookedSentType && SentType[appt.prebookedSentType]
      setPrebookedText(strText1)
    }
    if(appt.dateFirst != null){
      let strText2 = "First Reminder sent on "+appt.dateFirst+ "by "+appt.firstSentType && SentType[appt.firstSentType]
      setFirstText(strText2)
    }
    if(appt.dateSecond != null){
      let strText3 = "Second Reminder sent on "+appt.dateSecond+ " by "+appt.secondSentType && SentType[appt.secondSentType]
      setSecondText(strText3)
    }
     
    if(appt.dateLast != null){
      let strText4 = "Last Reminder sent on "+appt.dateLast+ " by "+appt.lastSentType && SentType[appt.lastSentType]
      setLastText(strText4)
    }
      
    if(appt.dateSameDay != null){
      let strText5 = "Sameday Reminder sent on "+appt.dateSameDay+ " by "+appt.sameDaySentType && SentType[appt.sameDaySentType]
      setSameDayText(strText5)
    }
  },[])
  const handleExpand = () =>{
    setIsExpanded(!isExpanded)
  }

 const handleConfirmCancel = (appId,confirmType)=>{
  console.log("Clicked Appt : "+appId)
  appointmentService.updateAppointmentStatus(appt.clinicId,appId,confirmType)
  .then(res=>{
    if(res.status === 200){
      toast.success("Appointment status updated successfully")
    }
  })
  .catch(err=>{
    console.log(err)
  })
 }


  return (
    <>
      <tr key={appt.id}>
        <td>
          <div className="form-check form-check-sm form-check-custom form-check-solid">
            <input className="form-check-input" type="checkbox" value={appt.appointmentId+" "+appt.firstName+" "+appt.lastName} 
              onClick={(e)=>handleCheckbox(e)}
              checked={isSelected}
            />
          </div>
        </td>
        <td>
        <div className="d-flex flex-column">
            <span data-text={appt.appointmentId}>  {appt.startTime} - {appt.endTime}</span>
            <span className="text-muted fs-7 mt-1">{ConfirmedMessage[appt.isConfirmed]}</span>

        </div>
        
        </td>
        <td colSpan={3} className="">
          <div className="d-flex flex-column align-items-center">
            <div
              className="d-flex justify-content-between align-items-center mb-2"
              style={{ width: "100%" }}
            >
              <span className="fw-bold text-hover-primary fs-3">
                {appt.firstName} {appt.lastName}{" "}
                {appt.preferredName && appt.preferredName}
              </span>
              <div>
                <span className="me-2"
                  data-tooltip-id="reminder-tooltip"
                  data-tooltip-content ={prebookedText}
                  data-tooltip-place="bottom"

                >
                  {" "}
                  <i className={clsx('bi','bi-alarm','fs-3',{'text-success' : appt.prebookedStatus === 1},{'text-danger':appt.prebookedStatus === 0})}></i>{" "}
                </span>
                <span className="me-2"
                 data-tooltip-id="reminder-tooltip"
                 data-tooltip-content ={firstText}
                 data-tooltip-place="bottom"
                >
                  {" "}
                  <i className="bi bi-alarm fs-3"></i>{" "}
                </span>
                <span className="me-2"
                 data-tooltip-id="reminder-tooltip"
                 data-tooltip-content ={secondText}
                 data-tooltip-place="bottom"
                >
                  {" "}
                  <i className="bi bi-alarm fs-3"></i>{" "}
                </span>
                <span className="me-2"
                 data-tooltip-id="reminder-tooltip"
                 data-tooltip-content ={LastText}
                 data-tooltip-place="bottom"
                >
                  {" "}
                  <i className="bi bi-alarm fs-3"></i>{" "}
                </span>
                <span className="me-2"
                 data-tooltip-id="reminder-tooltip"
                 data-tooltip-content ={sameDayText}
                 data-tooltip-place="bottom"
                >
                  {" "}
                  <i className="bi bi-alarm fs-3"></i>{" "}
                </span>
              </div>
              <Tooltip id="reminder-tooltip" />
            </div>

            <div
              className="d-flex align-items-center"
              style={{ width: "100%" }}
            >
              {appt.email && (
                <span className="text-hover-primary text-muted me-3">
                  <i className="bi bi-envelope-fill"></i> {appt.email}
                </span>
              )}
              {appt.phoneNumber && (
                <span className="text-hover-primary text-muted me-3">
                  <i className="bi bi-house-fill"></i> {appt.phoneNumber}
                </span>
              )}
              {appt.cellNumber && (
                <span className="text-hover-primary text-muted me-3">
                  <i className="bi bi-phone-fill"></i> {appt.cellNumber}
                </span>
              )}
            </div>
            <div className="d-flex flex-column w-100">
              <span className="text-muted fs-7 mt-1">
               Type:  {appt.type && appt.type}
              </span>
            </div>
            <div className="d-flex flex-column w-100">
              <span className="text-muted fs-7 mt-1">
               Reason:  {appt.reason && appt.reason}
              </span>
            </div>
          </div>
        </td>
        <td className="text-end">

            <div className="d-flex flex-column">
              <span className="btn btn-secondary btn-sm" 
              data-tooltip-id={"tooltip_appt_"+appt.appointmentId}
             
              data-tooltip-place = 'bottom'

              
              >More</span>
              <Tooltip id={"tooltip_appt_"+appt.appointmentId} clickable style={{backgroundColor:'#f8f9fa'}}> 
                <div className="d-flex flex-column">
                            <button className="btn btn-sm btn-light-primary me-2 mb-2" onClick={()=>handleConfirmCancel(appt.appointmentId,"CONFIRM")}> <i className="bi bi-check2-circle"></i> Confirm Appointment</button>
                            <button className="btn btn-sm btn-light-danger me-2 mb-2" onClick={()=>handleConfirmCancel(appt.appointmentId,"CANCEL")}> <i className="bi bi-x-circle"></i> Cancel Appointment</button>
                       
                </div>
              </Tooltip>

                 </div>
        </td>
      </tr>
     
    </>
  );
}

export default AppointmentListItem;
